import { type FC, useCallback, useEffect } from "react";

import { CourseCodeView } from "components/materials/home/admin/content/courses/CourseView";
import { TermsView } from "components/materials/home/admin/content/terms/TermsView";
import { type CourseViewOption } from "components/menus/SectionViewOptionMenu";
import { storeApi, useAppDispatch, useAppSelector } from "store/index";
import { selectLastCourseViewOption } from "store/selectors";
import { localStateActions } from "store/slices/local";

export const AdminCoursesView: FC = () => {
  const dispatch = useAppDispatch();
  const courseViewOption =
    useAppSelector(selectLastCourseViewOption) || ("course_code" as CourseViewOption);

  useEffect(() => {
    storeApi.course_code_groupings.list();
  }, []);

  const handleOptionChange = useCallback(
    (option: CourseViewOption) => {
      dispatch(localStateActions.setLastCourseViewOption(option));
    },
    [dispatch],
  );

  return courseViewOption === "course_code" ? (
    <CourseCodeView onOptionChange={handleOptionChange} />
  ) : (
    <TermsView onOptionChange={handleOptionChange} />
  );
};
